import React, { useEffect, useState , useRef} from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores';
import PreviewBrief from '../BriefPreview';
import BackIcon from '../../../assets/images/BackArrow.svg';
import EditIcon from '../../../assets/images/EditIcon.svg';
import { useServerFilter } from "../../../hooks/useServerFilter";
import { useServerFilterBriefs } from "../../../hooks/useBriefFilter";
import './style.scss';
import { TextInput, TextInputDropdown, SearchBar } from '../../../components';
import { MenuItem } from "@mui/material";
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`

var mobile = require('is-mobile');

const ViewProfessional = observer(({ backClick, selectedPro, allUsers, leads, pros }) => {
    const { userStore, uiStore , projectStore,briefStore} = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [IsEdit, setIsEdit] = useState(false);
    const [activeTab, setActiveTab] = useState('profile');
    const [User, setUser] = useState(selectedPro);
    const [ViewProject, setViewProject] = useState(false);
    const [TypeSelected, setTypeSelected] = useState('Brief');
    const [Briefs, setBriefs] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [SelectedProject, setSelectedProject] = useState({});
    const [AllProjects, setAllProjects] = useState([]);
    const [AvailProjects, setAvailProjects] = useState([]);
    const [FullName, setFullName] = useState(`${selectedPro.firstName} ${selectedPro.lastName}`);
    const [Leads, setLeads] = useState([]);
    const [Professionals, setProfessionals] = useState([]);
    const [Projects, setProjects] = useState([]);
    const [IsEdited, setIsEdited] = useState(false);
    const [Pagination, setPagination] = useState({ 
                currentPage :  1, 
                hasMore     : false, 
                nextCursor  : "", 
                prevCursor  : "",
                pageSize    : 8, 
                totalPages  : 0, 
                totalUsers  : 0
        })
    const didMount = useRef(false);
    const { serverFilterBriefs } = useServerFilterBriefs({ briefStore, uiStore, setBriefs: setBriefs, setPagination, searchTerm });
    const { serverFilterProject } = useServerFilter({ projectStore, uiStore, setAvailBriefs:setProjects, setPagination, searchTerm });
    
    useEffect(() => {
        getUsers();
    }, [selectedPro]);
    useEffect(() => {
        if (!didMount.current) {
          // first render, do nothing
          didMount.current = true;
          return;
        }
            
        if (searchTerm !== "") {
          serverFilterProject(null, searchTerm, null, null, selectedPro._id, 3);
          serverFilterBriefs(searchTerm, null, null, selectedPro._id, 3);
        } else {
          serverFilterProject(null, null, null, null, selectedPro._id, 3);
          serverFilterBriefs(null, null, null, selectedPro._id, 3);
        }
    }, [searchTerm]);
    useEffect(() => {
        let allProjects = [...Projects, ...Briefs];
        setAllProjects(allProjects);
    }, [Projects, Briefs]); 

    const getUsers = async () => {
        try {
            uiStore.setLoading(true);
            let fullName = `${selectedPro?.firstName ??""} ${selectedPro?.lastName ??""}`;
            await Promise.all([
                serverFilterProject( "", "", "","", selectedPro._id, 3),
                serverFilterBriefs( "", "","", selectedPro._id, 3)
            ]).then(() => {
                setFullName(fullName);
                setLeads(leads);
                setProfessionals(pros);
                setUser(selectedPro);
                uiStore.setLoading(false);
            }); 
        } catch (e) {
            console.error(e);
            uiStore.showNotification('Failed to fetch user data.', 'error');
        } finally {
            uiStore.setLoading(false);
        }
    };
    const truncateString = (str, num) => {
        if (str.length <= num) {
            return str;
        }
        return str.slice(0, num) + '...';
    };
    const handleTabClick = (tab) => {
        setIsEdit(false);
        setActiveTab(tab);
        forceUpdate();
    };
    const handleEditUser = () => {
        setIsEdit(true);
        forceUpdate();
    };
    const handleNavigateToMainScreen = () => {
        backClick(false, IsEdited);
        forceUpdate();
    };
    const handleTabChange = (e) => {
        setTypeSelected(e.currentTarget.id);
        forceUpdate();
    };
    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
    };
    const handleSearchChange = (value) => {
        setSearchTerm(value);
    };
    const handleUserInfoChange = (e) => {
        let user = User;
        if (!Object.keys(user).includes('professional')) {
            user['professional'] = {
                gender: '',
                languages: ''
            }
        }
        if (e.currentTarget.id === 'FullName') {
            let fullName = e.target.value;
            user.firstName = fullName.split(' ')[0];
            user.lastName = fullName.split(' ')[1];
            setFullName(fullName);
            user['fullName'] = `${user.firstName} ${user.lastName}`
        }
        if (e.currentTarget.id === 'dailyRate') {
            user.professional.ratePerDay = e.target.value;
        }
        if (e.currentTarget.id === 'Phone') {
            user.phone = e.target.value;
        }
        if (e.currentTarget.id === 'Email') {
            user.email = e.target.value;
        }
        if (e.currentTarget.id === 'AccountType') {
            user.accountType = e.target.value;
        }
        if (e.currentTarget.id === 'paymentMethod') {
            user.paymentMethod = e.target.value;
        }
        if (e.currentTarget.id === 'languages') {
            User.professional.languages = e.target.value;
        }
        if (e.currentTarget.id === 'location') {
            let location = e.target.value;
            user.state = location
        }
        setUser(user);
        forceUpdate();
    };
    const updateUserClicked = async () => {
        try {
            uiStore.setLoading(true);

            let user = User;
            let id = user._id;
            let isedited = false;
            delete user.briefs
            delete user.projects

            let update = await userStore.updateUserById(id, user);
            if (update !== 'error') {
                isedited = true;
                setIsEdited(isedited);
                
                // Show success notification instead of redirecting
                uiStore.showNotification('User updated successfully!', 'success');
                
                // Reset edit mode but stay on the same page
                setIsEdit(false);
                
                return;
            } else {
                uiStore.showNotification('Error updating user.', 'error');
            }

            setIsEdited(isedited)
        } catch (e) {
            console.error(e);
            uiStore.showNotification('Failed to update user.', 'error');
        } finally {
            uiStore.setLoading(false);
        }
    }
    const cancelUpdateUser = () => {
        setIsEdit(false);
        forceUpdate();
    };
    const getSelectedProject = (id) => {
        let projects = [...AllProjects];
        let selectedProject = projects.find(project => project._id === id);
        setSelectedProject(selectedProject);
        setViewProject(true);
        forceUpdate();
    };
    const backClicked = (e, isUpdate) => {
        if (isUpdate) {
            setIsEdited(true);
            backClick(false, true);
        } else {
            setViewProject(e);
            forceUpdate();
        }
    }

    function handleUserGenderChange(e) {
        let user = { ...User };
        if (Object.keys(user).includes('professional')) {
            if (user.professional !== null) {
                if (user.professional.gender) {
                    user.professional.gender = e.target.value;
                } else {
                    user.professional['gender'] = e.target.value;
                }
            } else {
                user['professional'] = {
                    gender: e.target.value,
                }
            }
        } else {
            user['professional'] = {
                gender: e.target.value,
            }
        }
        setUser(user)
        forceUpdate()
    }

    function handleUserExpChange(e) {
        let user = { ...User };
        user.experienceLevel = e.target.value;

        if (user['experienceLevel']) {
            user.experienceLevel = e.target.value;
        } else {
            user['experienceLevel'] = e.target.value
        }
        setUser(user)
    }

    function handleUserTheRoleChange(e) {
        let pro = { ...User }
        if (typeof pro.professional === 'object') {
            if (pro.professional) {
                pro.professional.services = e.target.value
            } else {
                pro.professional = {
                    services: e.target.value
                };
            }
        } else {
            pro['professional'] = {
                computerAccess: '',
                dateOfBirth: "",
                digitalMarketing: {},
                freelanceExperience: '',
                gender: '',
                internetAccess: '',
                languages: '',
                qualificationsAndCertificates: '',
                race: '',
                ratePerDay: '',
                ratePerHour: '',
                services: '',
                workingHours: ''
            }
            if (pro.professional) {
                pro.professional.services = e.target.value;
            } else {
                pro.professional = { services: e.target.value };
            }
        };
        setUser(pro)
    }

    function formatCash(value) {
        if (!value) return '0,00';

        value = value.toString().replace(/[^\d,]/g, '');
        let [integerPart, decimalPart] = value.split(',');
        integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        decimalPart = decimalPart ? decimalPart.slice(0, 2) : '00';

        return `${integerPart},${decimalPart}`;
    };
    if (mobile()) {
        return (
            <div>
            </div>
        );

    } else {
        return (
            <>
                {(ViewProject) ?
                    <div style={{ width: '100%', height: '100%' }}>
                        <PreviewBrief AllUsers={allUsers} project={SelectedProject} navigateMainToPage={(e, isUpdate) => backClicked(e, isUpdate)} professionals={Professionals} leads={Leads} />
                    </div>
                    :
                    <div className='ViewUser-Container'>
                        <div className='userDetailsSection'>
                            <div className='user-info-headerSection'>
                                <img src={BackIcon} onClick={handleNavigateToMainScreen} />
                                <p>{User.firstName || ''} {User.lastName || ''}</p>
                            </div>

                            <div className='user-info-bodySection'>
                                <div className='user-profile-CompDetails'>
                                    <div className='Profile-Picture'>
                                        <img src={UserIcon} style={{ width: '100%', height: '100%' }} />
                                    </div>
                                    <div className='user-oragnisationDetails'>
                                        <p style={{ margin: '0px' }}>{User.organisation || ''}</p>
                                        <p >{User.email || ''}</p>
                                        <p>{User?.professional?.services ?? ''}</p>
                                    </div>
                                </div>

                                <div className='userEdit-AccountDetails'>
                                    <div className="tab-container">
                                        <div className="tabs">
                                            <div className={`tab ${activeTab === 'profile' ? 'active' : ''}`} onClick={() => handleTabClick('profile')}>
                                                Profile
                                            </div>
                                            <div className={`tab ${activeTab === 'bank-details' ? 'active' : ''}`} onClick={() => handleTabClick('bank-details')}>
                                                financial Details
                                            </div>
                                        </div>
                                        <div className={`underline ${activeTab}`}></div>
                                    </div>
                                    <img src={EditIcon} style={{ width: '5%', cursor: 'pointer' }} onClick={handleEditUser} />
                                </div>

                                {(IsEdit && activeTab === 'profile') ?
                                    <div className='user-credentials'>
                                        <div className='editname-Contact-Details'>
                                            <TextInput style={{ width: '47%' }} label='Name & Surname' placeholder='Name & Surname' value={FullName} id='FullName' onChange={handleUserInfoChange} />
                                            <TextInput style={{ width: '47%' }} label='Contact Number' placeholder='Contact Number' value={User.phone} id='Phone' onChange={handleUserInfoChange} />
                                        </div>
                                        <div className='editname-Contact-Details'>
                                            <TextInput style={{ width: '47%' }} label='Email' placeholder='Email' value={User.email} id='Email' onChange={handleUserInfoChange} />
                                            {User?.roles?.length > 0 && User.roles[0] === 1988 ?
                                                <TextInputDropdown style={{ width: '47%' }} value={User?.professional?.services ? User.professional.services : 'Not Assigned'} id={'Role'} label='Role' onChange={handleUserTheRoleChange} >
                                                    {
                                                        ['Design and Illustration', 'Digital Marketing and Social Media', 'Film Photography and Videography', 'Software Development', 'Writing', 'PR', 'Other'].map((item, index) => {
                                                            return (<MenuItem key={index} id={index} value={item}>{item}</MenuItem>)
                                                        })
                                                    }
                                                </TextInputDropdown>
                                                :
                                                <TextInput style={{ width: '47%' }} label='Role' placeholder='Role' value={User?.role ? User.role : ''} id='role' />
                                            }
                                        </div>
                                        <div className='editname-Contact-Details'>
                                            <TextInputDropdown style={{ width: '47%' }} value={User.professional?.gender ? User.professional.gender : 'Not Assigned'} id={'gender'} label='Gender' onChange={handleUserGenderChange} >
                                                <MenuItem value='Not Assigned'>Select</MenuItem>
                                                <MenuItem value='Male'>Male</MenuItem>
                                                <MenuItem value='Female'>Female</MenuItem>
                                                <MenuItem value='Prefer Not To Say'>Prefer Not To Say</MenuItem>
                                            </TextInputDropdown>
                                            <TextInputDropdown style={{ width: '47%' }} id={'experience'} value={User.experienceLevel} label='Experience Level' onChange={handleUserExpChange} >
                                                <MenuItem value='Entry Level'>Entry Level</MenuItem>
                                                <MenuItem value='Junior'>Junior</MenuItem>
                                                <MenuItem value='Junior-Intermediate'>Junior-Intermediate</MenuItem>
                                                <MenuItem value='Intermediate'>Intermediate</MenuItem>
                                                <MenuItem value='Intermediate-Senior'>Intermediate-Senior</MenuItem>
                                                <MenuItem value='Senior'>Senior</MenuItem>
                                            </TextInputDropdown>
                                        </div>
                                        <div className='editname-Contact-Details'>
                                            <TextInput style={{ width: '47%' }} label='Languages' placeholder='Languages' value={User.professional?.languages || ''}
                                                id='languages' onChange={handleUserInfoChange} />
                                            <TextInput style={{ width: '47%' }} label='Location' placeholder='Location' value={User.state || ''}
                                                id='location' onChange={handleUserInfoChange} />
                                        </div>
                                        <div className='action-section'>
                                            <button className='btn-Cancel' onClick={cancelUpdateUser}>Cancel</button>
                                            <button className='btn-Save' onClick={updateUserClicked}>Save</button>
                                        </div>
                                    </div>
                                    :
                                    (IsEdit && activeTab == 'bank-details') ?
                                        <div className='user-credentials'>
                                            <div className='name-contactsection'>
                                                <div className='namesect'>
                                                    <p className='placeHolder'>Total Income</p>
                                                    <p className='value'>ZAR {User.totalAmount ?? 0.00}</p>
                                                </div>
                                                <div className='contactsect'>
                                                    <TextInput className='userInfoFields' style={{ width: '99%' }} placeholder='0,00' label='Daily Rate' id='dailyRate' value={User?.professional?.ratePerDay ?? ''} onChange={handleUserInfoChange}></TextInput>
                                                </div>
                                            </div>
                                            <div className='email-roleSection'>
                                                <div className='emailsect'>
                                                    <p className='placeHolder'>Total Credits</p>
                                                    <p className='value'>{undefined || 0}</p>
                                                </div>
                                                <div className='rolesect'>
                                                    <p className='placeHolder'>Credipple Rating</p>
                                                    <p className='value'>{User.averageRating || 'Not Assigned'}</p>
                                                </div>
                                            </div>
                                            <div className='email-roleSection'>
                                                <div className='emailsect'>
                                                    <p className='placeHolder'>Total Booking</p>
                                                    <p className='value'>{(User.projects?.length ?? 0) + (User.briefs?.length ?? 0)}</p>
                                                </div>
                                            </div>
                                            <div className='action-section'>
                                                <button className='btn-Cancel' onClick={cancelUpdateUser}>Cancel</button>
                                                <button className='btn-Save' onClick={updateUserClicked}>Save</button>
                                            </div>
                                        </div>
                                        :
                                        (activeTab === 'profile') ?
                                            <div className='user-credentials'>
                                                <div className='name-contactsection'>
                                                    <div className='namesect'>
                                                        <p className='placeHolder'>Name & Surname</p>
                                                        <p className='value'>{User.firstName || ''} {' '}{User.lastName || ''}</p>
                                                    </div>
                                                    <div className='contactsect'>
                                                        <p className='placeHolder'>Contact Number</p>
                                                        <p className='value'>{User.phone || 'Not Assigned'}</p>
                                                    </div>
                                                </div>
                                                <div className='email-roleSection'>
                                                    <div className='emailsect'>
                                                        <p className='placeHolder'>Email</p>
                                                        <p className='value'>{User.email || 'Not Assigned'}</p>
                                                    </div>
                                                    {User.roles.length > 0 && User.roles[0] === 1988 ?
                                                        <div className='rolesect' >
                                                            <p className='placeHolder'>Role</p>
                                                            <p className='value'>{User?.professional?.services ? User.professional.services : "Not Assigned"}</p>
                                                        </div>
                                                        : null
                                                    }
                                                </div>
                                                <div className='email-roleSection'>
                                                    <div className='emailsect'>
                                                        <p className='placeHolder'>Gender</p>
                                                        <p className='value'>{User.professional?.gender ? User.professional.gender : 'Not Assigned'}</p>
                                                    </div>
                                                    <div className='rolesect'>
                                                        <p className='placeHolder'>Experience Level</p>
                                                        <p className='value'>{User.experienceLevel || 'Not '}</p>
                                                    </div>
                                                </div>
                                                <div className='email-roleSection'>
                                                    <div className='emailsect'>
                                                        <p className='placeHolder'>Language</p>
                                                        <p className='value'>{User.professional?.languages ? User.professional.languages : 'Not Assigned'}</p>
                                                    </div>
                                                    <div className='rolesect'>
                                                        <p className='placeHolder'>Location</p>
                                                        <p className='value'>{`${User.state || ''}` || 'Not Assigned'}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            (activeTab === 'bank-details') ?
                                                <div className='user-credentials'>
                                                    <div className='name-contactsection'>
                                                        <div className='namesect'>
                                                            <p className='placeHolder'>Total Income</p>
                                                            <p className='value'>ZAR {User.totalAmount ?? 0.00}</p>
                                                        </div>
                                                        <div className='contactsect'>
                                                            <p className='placeHolder'>Daily Rate</p>
                                                            <p className='value'>{`ZAR ${formatCash(User?.professional?.ratePerDay ?? 0)}`}</p>
                                                        </div>
                                                    </div>
                                                    <div className='email-roleSection'>
                                                        <div className='emailsect'>
                                                            <p className='placeHolder'>Total Credits</p>
                                                            <p className='value'>{undefined || 0}</p>
                                                        </div>
                                                        <div className='rolesect'>
                                                            <p className='placeHolder'>Credipple Rating</p>
                                                            <p className='value'>{User.averageRating || 'Not Assigned'}</p>
                                                        </div>
                                                    </div>
                                                    <div className='email-roleSection'>
                                                        <div className='emailsect'>
                                                            <p className='placeHolder'>Total Booking</p>
                                                            <p className='value'>{User.projects?.length ?? 0 + User.briefs?.length ?? 0}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                null
                                }

                            </div>
                        </div>
                        <div className='user-project-section'>
                            <div className='project-header-container'>
                                <p >{TypeSelected}</p>
                                <div className='search-bar-section' style={{ width: '45%' }}>
                                    {/* <img src={SearchIcon} alt='Search Icon' />
                                    <input style={{ color: '#6D4194' }} placeholder='Search' onChange={handleSearchChange} value={searchTerm}></input>
                                 */}
                                 <SearchBar
                                    onSearch={(e)=>handleSearchChange(e)}
                                    placeholder='Search'
                                    debounceDelay={1000}
                                    disabled={false}
                                    className=''
                                    searchIconUrl={SearchIcon}
                                    style={{ width: '100%' }}
                                />
                                </div>
                            </div>
                            
                            <div className='available-projects-container'>
                                {TypeSelected === 'Brief' ?
                                    Array.isArray(Briefs) && Briefs.length > 0 && Briefs.map((item, index) => {
                                        return (
                                            <div className='project-Card' key={index} onClick={() => getSelectedProject(item._id)}>
                                                <div className='briefHeaderSection'>
                                                    <p>{item.briefTitle}</p>
                                                </div>
                                                <div className='briefDetailssection'>
                                                    <div className='detailsSections'>
                                                        <div className='profileSection' style={{ width: '60%' }}>
                                                            <div className='profile'>
                                                                <img className='profilePicture' src={UserIcon} />
                                                            </div>
                                                            <div className='details'>
                                                                <p className='ValueplaceHolder'> {truncateString(`${item.client.firstName} ${item.client.lastName}`, 15)}</p>
                                                                <p className='textValue'> {item.client.accountType === 'personal' ? (item?.client?.email?.length > 15 ? String(`${item.client.firstName} ${item.client.lastName}`).substring(0, 13) + '...' : item?.client?.email) : (item?.client?.website?.length > 15 ? item.client.website.substring(0, 13) + '...' : item?.client?.website)}</p>
                                                            </div>
                                                        </div>
                                                        <div className='detailContainer' style={{ width: '40%' }}>
                                                            <p className='ValueplaceHolder'>Start Date</p>
                                                            <p className='textValue'>{formatDate(item.projectStartDate) || ''}</p>
                                                        </div>
                                                    </div>
                                                    <div className='detailsSections'>
                                                        <div className='detailContainer' style={{ width: '60%' }}>
                                                            <p className='ValueplaceHolder'>Category of Service</p>
                                                            <p className='textValue'>{item?.serviceCategory ? item.serviceCategory : 'Not Assigned'}</p>
                                                        </div>
                                                        <div className='detailContainer' style={{ width: '40%' }}>
                                                            <p className='ValueplaceHolder'>Fulfillment Lead</p>
                                                            <p className='textValue'>{item?.talentPartner ? `${item.talentPartner.firstName} ${item.talentPartner.lastName}` : ''}</p>
                                                        </div>
                                                    </div>
                                                    <div className='detailsSections'>
                                                        <div className='detailContainer' style={{ width: '60%' }}>
                                                            <p className='ValueplaceHolder'>Professionals</p>
                                                            <p className='textValue'>{item?.projectPlan && Array.isArray(item.projectPlan) && item.projectPlan.length > 0 && typeof item.projectPlan[0].professional === 'object' ? `${item.projectPlan[0].professional.firstName} ${item.projectPlan[0].professional.lastName}` : `Not Assigned`}</p>
                                                        </div>
                                                        <div className='detailContainer' style={{ width: '40%' }}>
                                                            <p className='ValueplaceHolder'>Fulfillment Stage</p>
                                                            <p className='textValue'>{item?.projectPlan[0]?.fulfillmentStage?? 'Not Assigned'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                    :
                                    Array.isArray(Projects) && Projects.length > 0 && Projects.map((item, index) => {
                                        return (
                                            <div className='project-Card' key={index} onClick={() => getSelectedProject(item._id)}>
                                                <div className='briefHeaderSection'>
                                                    <p>{item.title || ''}</p>
                                                </div>
                                                <div className='briefDetailssection'>
                                                    <div className='detailsSections'>
                                                        <div className='profileSection' style={{ width: '60%' }}>
                                                            <div className='profile'>
                                                                <img className='profilePicture' src={UserIcon} />
                                                            </div>
                                                            <div className='details'>
                                                                <p className='ValueplaceHolder'> {truncateString(`${item.client.firstName} ${item.client.lastName}`, 15)}</p>
                                                                <p className='textValue'> {item.client.accountType === 'personal' ? (item?.client?.email?.length > 15 ? String(`${item.client.firstName} ${item.client.lastName}`).substring(0, 13) + '...' : item?.client?.email) : (item?.client?.website?.length > 15 ? item.client.website.substring(0, 13) + '...' : item?.client?.website)}</p>
                                                            </div>
                                                        </div>
                                                        <div className='detailContainer' style={{ width: '40%' }}>
                                                            <p className='ValueplaceHolder'>Start Date</p>
                                                            <p className='textValue'>{item?.projectPlan?.projStartDate ? formatDate(new Date(item.projectPlan.projStartDate)) : 'No Date'}</p>
                                                        </div>
                                                    </div>
                                                    <div className='detailsSections'>
                                                        <div className='detailContainer' style={{ width: '60%' }}>
                                                            <p className='ValueplaceHolder'>Category of Service</p>
                                                            <p className='textValue'>{item?.serviceCategory ? item.serviceCategory : 'Not Assigned'}</p>
                                                        </div>
                                                        <div className='detailContainer' style={{ width: '40%' }}>
                                                            <p className='ValueplaceHolder'>Fulfillment Lead</p>
                                                            <p className='textValue'>{item?.fulfillmentLead?.firstName || ''} {item?.fulfillmentLead?.lastName || ''}</p>
                                                        </div>
                                                    </div>
                                                    <div className='detailsSections'>
                                                        <div className='detailContainer' style={{ width: '60%' }}>
                                                            <p className='ValueplaceHolder'>Professionals</p>
                                                            <p className='textValue'>{User.firstName || ''} {User.lastName || ''}</p>
                                                        </div>
                                                        <div className='detailContainer' style={{ width: '40%' }}>
                                                            <p className='ValueplaceHolder'>Fulfillment Stage</p>
                                                            <p className='textValue'>{item?.projectPlan?.fulfillmentStage || 'Not Assigned'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>


                            <div className='viewBriefTypeSect' style={{ width: '93%' }}>
                                <div className={(TypeSelected === 'Brief' ? 'selectedType' : 'typeCard')} id='Brief' onClick={handleTabChange}>
                                    <p>Briefs</p>
                                </div>
                                <div style={{ marginLeft: '1.5%' }} className={(TypeSelected === 'Project' ? 'selectedType' : 'typeCard')} id='Project' onClick={handleTabChange}>
                                    <p>Projects</p>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    }
})

export default ViewProfessional;